import {
  FETCH_DISPUTES,
  FETCH_DISPUTES_SUCCESS,
  FETCH_DISPUTES_FAILED,
  EDIT_DISPUTE
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, push, set, remove, ref, orderByChild, query, equalTo, get } from "firebase/database";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { chatMail } from './admchatactions';

export const disputeChatMail = chatMail;

export const fetchDisputes = (uid = null, role = 'admin') => (dispatch) => {
  const { database } = firebase;
  const disputesRef = ref(database, 'disputes');
  
  dispatch({
    type: FETCH_DISPUTES,
    payload: null,
  });

  let queryRef = disputesRef;
  if (role === 'rider') {
    queryRef = query(disputesRef, orderByChild('passenger_id'), equalTo(uid));
  } else if (role === 'driver') {
    queryRef = query(disputesRef, orderByChild('driver_id'), equalTo(uid));
  }

  onValue(queryRef, (snapshot) => {
    if (snapshot.exists()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: FETCH_DISPUTES_SUCCESS,
        payload: arr.reverse()
      });
    } else {
      dispatch({
        type: FETCH_DISPUTES_FAILED,
        payload: "No disputes found.",
      });
    }
  });
};

export const editDispute = (disputeData, method) => (dispatch) => {
  const { database } = firebase;
  const disputesRef = ref(database, 'disputes');

  dispatch({
    type: EDIT_DISPUTE,
    payload: { method, disputeData }
  });
  
  if (method === 'Add') {
    disputeData.createdAt = new Date().getTime();
    push(disputesRef, disputeData);
  } else if (method === 'Update') {
    set(ref(database, `disputes/${disputeData.id}`), { ...disputeData, updatedAt: new Date().getTime() });
  } else if (method === 'Delete') {
    remove(ref(database, `disputes/${disputeData.id}`));
  }
};

export const addDisputeMessage = (disputeId, messageData) => async (dispatch) => {
  const { database, singleUserRef } = firebase;
  const messagesRef = ref(database, `disputes/${disputeId}/messages`);
  
  const timestamp = new Date().getTime();
  messageData.timestamp = timestamp;
  
  await push(messagesRef, messageData);
  
  // Update the dispute's updatedAt field
  set(ref(database, `disputes/${disputeId}/updatedAt`), timestamp);

  try {
    const disputeSnap = await get(ref(database, `disputes/${disputeId}`));
    const dispute = disputeSnap.val();
    if (!dispute) return;

    if (messageData.sender === 'admin') {
      // Admin sent a message -> Send Push Notification to Customer (Passenger)
      const passengerId = dispute.passenger_id;
      if (passengerId) {
        let pushToken = messageData.pushToken;
        if (!pushToken) {
          const userSnap = await get(singleUserRef(passengerId));
          const userProfile = userSnap.val();
          pushToken = userProfile?.pushToken;
        }

        if (pushToken) {
          const defaultLang = store.getState()?.languagedata?.defaultLanguage;
          const notifTitle = defaultLang?.notification_title 
            ? `${defaultLang.notification_title} ${dispute.subject ? `(${dispute.subject})` : ''}`.trim()
            : `Smart Ride - Dispute: ${dispute.subject || 'Refunds & Disputes'}`;

          RequestPushMsg(
            pushToken,
            {
              title: notifTitle,
              msg: messageData.text,
              screen: 'DisputeChat',
              params: { disputeId: disputeId }
            }
          );
        }
      }
    } else {
      // Customer (Passenger) sent a message -> Send Email to Admin
      let userId = messageData.userId || dispute.passenger_id;
      let userName = messageData.userName;
      let profileImage = messageData.profileImage;

      if (!userName || !profileImage) {
        if (userId) {
          const userSnap = await get(singleUserRef(userId));
          const userProfile = userSnap.val();
          if (userProfile) {
            userName = userName || `${userProfile.firstName || ''} ${userProfile.lastName || ''}`.trim() || 'Customer';
            profileImage = profileImage || userProfile.profile_image;
          }
        }
      }

      const mailObj = {
        userId: userId || 'unknown',
        userName: userName || 'Customer',
        message: messageData.text,
        profileImage: profileImage || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
        message_date: timestamp,
        subject: `Smart Ride Dispute Chat - ${dispute.subject || `Booking ${dispute.booking_id || disputeId}`}`,
        title: `Dispute Message: ${dispute.subject || 'Refunds & Disputes'}`,
        disputeId: disputeId,
        bookingId: dispute.booking_id
      };

      await chatMail(mailObj);
    }
  } catch (error) {
    console.error("Error sending dispute message notification/email:", error);
  }
};
